import { menuGroup, menuItem } from "modules/helpers";
import ControlledBuilders from "./ControlledBuilders.doc";

// components
import ContentBuilder from "./ContentBuilder.doc";
import FormBuilder from "./FormBuilder.doc";
import ModalBuilder from "./ModalBuilder.doc";
import ListBuilder from "./ListBuilder.doc";
import TriggerBuilder from "./TriggerBuilder.doc";

const components = [
  menuItem("<ContentBuilder/>", "content-builder", ContentBuilder),
  menuItem("<FormBuilder/>", "form-builder", FormBuilder),
  menuItem("<ModalBuilder/>", "modal-builder", ModalBuilder),
  menuItem("<ListBuilder/>", "list-builder", ListBuilder),
  menuItem("<TriggerBuilder/>", "trigger-builder", TriggerBuilder),
];

export default [
  menuItem("Controlled Builders", "controlled-builders", ControlledBuilders),
  menuGroup("Components", "components", components),
];
